module.exports = __webpack_public_path__ + "img/trade-swiper-2.0d4fd1fb.png";